import { render, staticRenderFns } from "./column-select.vue?vue&type=template&id=68ded852&"
import script from "./column-select.vue?vue&type=script&lang=js&"
export * from "./column-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports